import 'react-toggle/style.css';

import React from 'react';
import Toggle from 'react-toggle';

import propTypes from 'prop-types';

const ICON_CLASS = 'MembershipToggle__icon';

const OnIcon = function() {
  return <div className={ICON_CLASS}> ON </div>;
};

const OffIcon = function() {
  return <div className={ICON_CLASS}> OFF </div>;
};

export default class MembershipToggle extends React.Component {
  static propTypes = {
    isMembershipOrder: propTypes.bool.isRequired,
    hasSubscriptionCommitment: propTypes.bool.isRequired,
    changeOrderMembership: propTypes.func.isRequired,
    removeCommitmentRewardLineItemsAndDisableOrderMembership:
      propTypes.func.isRequired,
    eventLocation: propTypes.string.isRequired,
  };

  handleToggleChange = () => {
    const {
      changeOrderMembership,
      eventLocation,
      isMembershipOrder,
      hasSubscriptionCommitment,
      removeCommitmentRewardLineItemsAndDisableOrderMembership,
    } = this.props;

    if (isMembershipOrder === true && hasSubscriptionCommitment === true) {
      removeCommitmentRewardLineItemsAndDisableOrderMembership();
    } else {
      changeOrderMembership(!isMembershipOrder, eventLocation);
    }
  };

  render() {
    const { isMembershipOrder } = this.props;
    // NOTE: react-toggle's definition of "checked/unchecked icons"
    // is the opposite of how we display visually
    //
    // `checked` can be thought of as the "left" icon and vice versa with `unchecked`
    return (
      <div className="MembershipToggle membership-banner__auto-ship-enabled">
        <Toggle
          checked={isMembershipOrder}
          onChange={this.handleToggleChange}
          icons={{
            checked: <OffIcon />,
            unchecked: <OnIcon />,
          }}
        />
      </div>
    );
  }
}
